<div class="panel">
    <!-- DKM-5139 Clara: eski hâli
    <dx-tab-panel
      [showNavButtons]="false"
      [(selectedIndex)]="selectedTabIndex"
      [height]="'100%'"
    >
    -->
    <dx-tab-panel
      [showNavButtons]="false"
      [(selectedIndex)]="selectedTabIndex"
      [height]="'100%'"
      (onSelectionChanged)="onTabSelectionChanged($event)"
    >
    <dxi-item title="Üst Yazı" icon="pdffile">
      <div class="pdf-area">
        <!-- <ngx-extended-pdf-viewer
            [base64Src]="base64Src"
            [zoom]="'page-width'"
            [height]="'auto'"
            [(page)]="page"
            [(pageLabel)]="pageLabel"
            [textLayer]="true"
            [minifiedJSLibraries]="false"
            (pageRendered)="onPageRendered()">
            </ngx-extended-pdf-viewer> -->
      <!-- DKM-5164 Cedric: eski hâli
      <ng-container *ngIf="documentLoadUstYazi">
      -->
      <ng-container *ngIf="documentLoadUstYazi && !indirilirUstYazi">
          
            <dk-doc-viewer-manager
            [url]="fileUrlUstYazi"
          [isFileImage]="isFileImageUstYazi"
          [guvenliHtml]="htmlUstYazi"
          [failedDocMessage]="failedDocLoadMsgUstYazi"
          [documentLoad]="documentLoadUstYazi"
          [docId]="docId"
          [width]="770"   
          [height]="740"
          ></dk-doc-viewer-manager> 
      </ng-container>
      <!-- DKM-5164 Cedric: tarayıcının gösteremediği tür (Saysis tif, eyp, doc...) → kırık resim yerine indirme -->
      <div class="indir-bilgi" *ngIf="documentLoadUstYazi && indirilirUstYazi">
        <div class="indir-metin">Bu belge türü (.{{ ustYaziUzanti }}) tarayıcıda görüntülenemiyor. Dosyayı indirip açabilirsiniz.</div>
        <dx-button
          text="İndir"
          icon="download"
          type="default"
          stylingMode="contained"
          [width]="'fit-content'"
          (onClick)="ustYaziIndir()"
        ></dx-button>
      </div>

            <!-- <img
                *ngIf="isFileImageUstYazi && documentLoadUstYazi; else documentTemplateUstYazi"
                [src]="fileUrlUstYazi"
                (error)="onFileErrorUstYazi()"
              />
      
            <ng-template #documentTemplateUstYazi>
              <iframe
              type="application/pdf"
                *ngIf="!isFileImageUstYazi && documentLoadUstYazi; else noTemplateUstYazi"
                [src]="fileUrlUstYazi"
                (load)="onDocumentLoadUstYazi()"
                (error)="onFileErrorUstYazi()"
              ></iframe>
            </ng-template>
            <ng-template #noTemplateUstYazi>
              <div class="error-message">{{ failedDocLoadMsgUstYazi }}</div>
            </ng-template> -->
        <!-- <iframe
          type="application/pdf"
          [src]="fileUrl"
          (load)="onDocumentLoad()"
          (error)="onFileError()"
        ></iframe> -->
        <!-- <dk-word-viewer [docContent]="base64Src"  [docName]="dysName" [IsReadOnly]="true" ></dk-word-viewer> -->
      </div>
    </dxi-item>

      <dxi-item title="Üst Veri" icon="textdocument" *ngIf="!otherUstVeri">
        <dk-pdf-view-ust-veri
          [belgeKod]="belgeKod"
          [gelenGiden]="gelenGiden"
          [state]="'Edit'"
        ></dk-pdf-view-ust-veri>
      </dxi-item>
      <dxi-item title="Üst Veri" icon="textdocument" *ngIf="otherUstVeri">
        <dk-pdf-view-other-ust-veri
          [belgeKod]="belgeKod"
          [gelenGiden]="gelenGiden"
          [state]="'Edit'"
        ></dk-pdf-view-other-ust-veri>
      </dxi-item>
      <dxi-item title="Dağıtım" icon="message">
        <div class="flex-tab-item">
          <dk-dx-data-table2
            #dagitimGrid
            *ngIf="gridCtlDagitim$ | async as gridCtl"
            class="grid"
            [tableTittle]="'Dağıtım'"
            [height]="'100%'"
            [formMetaData]="formMetaData"
            [dListName]="this.dListNameDagitim"
            [dataSource]="dataSourceDagitim"
            [columnList]="columnListDagitim"
            [gridCtlList]="gridCtl"
            [focusedRowIndex]="0"
            (focusedRowChanged)="focusedRowChangedDagitim($event)"
            [cellTemplates]="[{ template: customItemTemplate, field: 'IslemTuru' }]"
          >
          </dk-dx-data-table2>
          <ng-template #customItemTemplate let-data="itemData" let-index="itemIndex">
            <span class="status status-{{ data.text }}">{{
            data.text | templateDataText
            }}</span>
          </ng-template>
          <ng-container *ngIf="focusedRowIndexDagitim >= 0">
            <dx-toolbar class="panel-toolbar" *ngIf="dagitimEditPermission && selectedBelgeDagitim?.GonderimDurum =='I'">
              <dxi-item location="after">
                <section class="form-sub-header-buttons">
                  <ng-container [ngSwitch]="editModeDagitim">
                    <ng-container *ngSwitchCase="false">
                      <dx-button
                        stylingMode="contained"
                        type="default"
                        text="Düzenle"
                        (onClick)="handleDagitimEditClick()"
                      ></dx-button>
                    </ng-container>
                    <ng-container *ngSwitchCase="true">
                      <dx-button
                        stylingMode="contained"
                        type="default"
                        text="Kaydet"
                        (onClick)="handleDagitimSaveClick()"
                      ></dx-button>
                      <dx-button
                        stylingMode="contained"
                        type="default"
                        text="İptal"
                        (onClick)="onDagitimCloseClick()"
                      ></dx-button>
                    </ng-container>
                  </ng-container>
                </section>
              </dxi-item>
            </dx-toolbar>
            <dx-form
              class="form"
              [(formData)]="selectedBelgeDagitim"
              [labelMode]="labelMode"
              [labelLocation]="labelLocation"
              [readOnly]="!editModeDagitim"
              [colCount]="2"
            >
            <dxi-item [colCount]="2" [colSpan]="2"
            itemType="group">
            <dxi-item [colCount]="2" [colSpan]="2" cssClass="border-group"
            itemType="group">
            <dxi-item
            [label]="{ text: 'Birim' }"
            dataField="BirimAciklama"
          >
          </dxi-item>
          <dxi-item
            [label]="{ text: 'Dagıtım Tür' }"
            dataField="DagitimSekli"
          >
<div *dxTemplate>
<dk-ct-gen-radio-btn
  [dataField]="'DagitimSekli'"
  [lookUpType]="'BYS_DAGITIM_BILGI_GEREK_LOOKUP'"
  [value]="selectedBelgeDagitim?.DagitimSekli"
  (valueChange)="selectedBelgeDagitim.DagitimSekli = $event"
  [readOnly]="true"
></dk-ct-gen-radio-btn>
</div>
          </dxi-item>
          <dxi-item
            [label]="{ text: 'Hitap Aciklama' }"
            dataField="Aciklama"
            editorType="dxTextArea"
            [editorOptions]="{ value: selectedBelgeDagitim?.Aciklama }"
          >
          </dxi-item>
          <dxi-item
            [label]="{ text: 'Gönderim Tipi' }"
            dataField="GonderimTipi"
          >
          
          <dk-ct-gen-lookup
                         [placeholder]="'Gönderim Tipi'"
          [selectedValue]="selectedBelgeDagitim?.GonderimTipi"
          [lookUpType]="'BYS_GONDERIM_TIPI'"
           [labelMode]="labelMode"
          [label]="'Gönderim Tipi'"
          [readOnly]="true"

          ></dk-ct-gen-lookup>
          </dxi-item>
          <dxi-item
          [label]="{ text: 'Birim Türü' }"
                         dataField="BirimTuru"
          >
          <dk-ct-gen-lookup
                         [placeholder]="'Birim Türü'"
          [selectedValue]="selectedBelgeDagitim?.BirimTuru"
          [lookUpType]="'BYS_BIRIM_TUR'"
           [labelMode]="labelMode"
          [label]="'Birim Türü'"
          [readOnly]="true"

          ></dk-ct-gen-lookup>

          </dxi-item>
          <dxi-item
            [label]="{ text: 'Kep Adresi' }"
            dataField="KepAdres"
          >
          </dxi-item>
          <dxi-item
            [label]="{ text: 'Birim Kimlik No' }"
            dataField="BirimKimlikNo"
          >
          </dxi-item>
          <dxi-item
            [label]="{ text: 'Gönderim Adresi' }"
            dataField="GonderimAdres"
          >
          </dxi-item>
          </dxi-item>


          <dxi-item
          [label]="{ text: 'Gönderim Durumu' }"
          dataField="GonderimDurum"
        >
        <dk-ct-gen-lookup
                       [placeholder]="'Gönderim Durumu'"
        [selectedValue]="selectedBelgeDagitim?.GonderimDurum"
        [lookUpType]="'BYS_GONDERİM_DURUM'"
         [labelMode]="labelMode"
        [label]="'Gönderim Durumu'"
        [readOnly]="true"

        ></dk-ct-gen-lookup>
        </dxi-item>
        <dxi-item
          [label]="{ text: 'Kep Durumu' }"
          dataField="KepDurum"
        >
        <dk-ct-gen-lookup
                       [placeholder]="'Kep Durumu'"
        [selectedValue]="selectedBelgeDagitim?.KepDurum"
        [lookUpType]="'BYS_KEP_DURUM'"
         [labelMode]="labelMode"
        [label]="'Kep Durumu'"
        [readOnly]="true"

        ></dk-ct-gen-lookup>
        </dxi-item>
          <dxi-item
            [label]="{ text: 'Gönderim Bedeli' }"
            dataField="GonderimBedeli"
          >
          </dxi-item>
          <dxi-item
            [label]="{ text: 'Kep Id' }"
            dataField="KepId"
          >
          </dxi-item>
          <dxi-item
            [label]="{ text: 'Red Nedeni' }"
            dataField="RedNedeni"
          >
          </dxi-item>
          <dxi-item
            dataField="KisiKod"
            [label]="{ text: 'Kişi' }"
          >
            <dk-ctl-gen-kisi
              [code]="selectedBelgeDagitim?.KisiKod"
              [labelText]="'Kişi'"
              [labelMode]="labelMode"
              [isReadOnly]="true"
            ></dk-ctl-gen-kisi>
          </dxi-item>
          </dxi-item>
            </dx-form>
          </ng-container>
        </div>
      </dxi-item>

      <dxi-item title="İlgi" icon="attach">
        <div class="flex-tab-item">
          <dk-dx-data-table2
            *ngIf="gridCtlIlgi$ | async as gridCtl"
            class="grid"
            [tableTittle]="'İlgiler'"
            [height]="'100%'"
            [formMetaData]="formMetaData"
            [dListName]="this.dListNameIlgi"
            [dataSource]="dataSourceIlgi"
            [columnList]="columnListIlgi"
            [gridCtlList]="gridCtl"
            [focusedRowIndex]="0"
            (focusedRowChanged)="focusedRowChangedIlgi($event)"
            [otherActionBtnList]="belgeGorBtn"
            (clickOtherBtn)="clickOtherBtn($event)"
            (rowPrepared)="onRowPrepared($event)"
            
          >
          </dk-dx-data-table2>
          <dx-form
            *ngIf="focusedRowIndexIlgi >= 0"
            class="form"
            [(formData)]="belgeIlgiData"
            [labelMode]="labelMode"
            [labelLocation]="labelLocation"
            [readOnly]="true"
            [colCount]="3"
          >
            <dxi-item
              dataField="Sira"
              [label]="{ text: 'Sıra' }"
              editorType="dxNumberBox"
            ></dxi-item>

            <dxi-item
              dataField="BelgeKod"
              [label]="{ text: 'Belge Kod' }"
              editorType="dxNumberBox"
            ></dxi-item>

            <dxi-item
              dataField="BirimKod"
              [label]="{ text: 'Birim Kod' }"
              editorType="dxNumberBox"
            ></dxi-item>

            <dxi-item
              dataField="IlgiTuru"
              [label]="{ text: 'İlgi Türü' }"
            ></dxi-item>

            <dxi-item
              dataField="ReferansKod"
              [label]="{ text: 'Referans Kod' }"
              editorType="dxNumberBox"
            ></dxi-item>

            <dxi-item
              dataField="EvrakTarih"
              [label]="{ text: 'Evrak Tarih' }"
              editorType="dxDateBox"
            ></dxi-item>

            <dxi-item
              dataField="EvrakNo"
              [label]="{ text: 'Evrak No' }"
              editorType="dxNumberBox"
            ></dxi-item>

            <dxi-item
              dataField="IlgiAciklama"
              [label]="{ text: 'İlgi Açıklama' }"
              editorType="dxTextArea"
            ></dxi-item>
          </dx-form>
        </div>
      </dxi-item>
      <!-- DKM-5139: belge ilişki silsilesi (önceki yazılar + cevaplar); sekme ilk açıldığında yüklenir -->
      <dxi-item title="İlişkiler" icon="hierarchy" *ngIf="belgeKod">
        <div class="flex-tab-item">
          <dk-belge-silsile
            *ngIf="iliskilerYuklendi"
            [belgeKod]="belgeKod"
            [formMetaData]="formMetaData"
          ></dk-belge-silsile>
        </div>
      </dxi-item>
      <dxi-item title="Ek" icon="attach">
        <div class="flex-tab-item">
          <dk-dx-data-table2
            *ngIf="gridCtl$ | async as gridCtl"
            class="grid"
            [tableTittle]="'Ekler'"
            [height]="'100%'"
            [formMetaData]="formMetaData"
            [dListName]="this.dListName"
            [dataSource]="dataSource"
            [columnList]="columnList"
            [gridCtlList]="gridCtl"
            [focusedRowIndex]="0"
            (focusedRowChanged)="focusedRowChangedEkler($event)"
          >
          </dk-dx-data-table2>
          <div class="ek-belge-area" *ngIf="focusedRowIndexEkler >= 0">
            <div class="ek-btn-area" *ngIf="belgeEklerData?.BelgeDysKod">
              <dx-button
                class="custom-button-item"
                [text]="'İndir'"
                type="default"
                [icon]="'download'"
                stylingMode="contained"
                [width]="'fit-content'"
                (onClick)="belgeIndir()"
              ></dx-button>
              <dx-button *ngIf="belgeEklerData?.BelgeAd?.toLowerCase()?.endsWith('pdf')"
                class="custom-button-item"
                [text]="'Göster'"
                type="default"
                [icon]="'eyeopen'"
                stylingMode="contained"
                [width]="'fit-content'"
                (onClick)="belgeGoster()"
              ></dx-button>
            </div>
            <dx-form
              class="form"
              [(formData)]="belgeEklerData"
              [labelMode]="labelMode"
              [labelLocation]="labelLocation"
              [readOnly]="true"
              [colCount]="3"
            >
              <dxi-item
                dataField="Sira"
                [label]="{ text: 'Sıra' }"
                editorType="dxNumberBox"
              ></dxi-item>

              <dxi-item
                dataField="BelgeKod"
                [label]="{ text: 'Belge Kod' }"
                editorType="dxNumberBox"
              ></dxi-item>

              <dxi-item
                dataField="ReferansKod"
                [label]="{ text: 'Referans Kod' }"
                editorType="dxNumberBox"
              ></dxi-item>

              <dxi-item
                dataField="BelgeTipKod"
                [label]="{ text: 'Belge Tip Kod' }"
              >
                <dk-ct-gen-lookup
                  [selectedValue]="belgeEklerData?.BelgeTipKod"
                  [lookUpType]="'GEN_BELGE_TIP'"
                  [label]="'Belge Tip Kod'"
                  [readOnly]="true"
                  [valueExpr]="'kod'"
                  [placeholder]="'-'"
                ></dk-ct-gen-lookup>
              </dxi-item>

              <dxi-item
                dataField="BelgeTuruKod"
                [label]="{ text: 'Belge Türü Kod' }"
                editorType="dxNumberBox"
              ></dxi-item>

              <dxi-item
                dataField="BelgePath"
                [label]="{ text: 'Belge Path' }"
              ></dxi-item>

              <dxi-item
                dataField="BelgeAd"
                [label]="{ text: 'Belge Ad' }"
              ></dxi-item>

              <dxi-item
                dataField="BelgeDysKod"
                [label]="{ text: 'Belge Dys Kod' }"
              ></dxi-item>

              <dxi-item
                dataField="BelgeTarih"
                [label]="{ text: 'Belge Tarih' }"
                editorType="dxDateBox"
              ></dxi-item>

              <dxi-item
                dataField="BelgeNo"
                [label]="{ text: 'Belge No' }"
                editorType="dxNumberBox"
              ></dxi-item>

              <dxi-item
                dataField="BelgeAciklama"
                [label]="{ text: 'Belge Açıklama' }"
                editorType="dxTextArea"
              ></dxi-item>

              <dxi-item
                dataField="AdetSayfa"
                [label]="{ text: 'Adet Sayfa' }"
              ></dxi-item>

              <dxi-item
                dataField="Boyut"
                [label]="{ text: 'Boyut' }"
                editorType="dxNumberBox"
              ></dxi-item>

              <dxi-item
                dataField="FizikselBelgeEh"
                [label]="{ text: 'Fiziksel Belge Eh' }"
              >
              <dk-ct-gen-radio-btn
    [lookUpType]="'GEN_EVETHAYIR'"
    [dataField]="'FizikselBelgeEh'"
    [value]="belgeEklerData?.FizikselBelgeEh"
    (valueChange)="belgeEklerData.FizikselBelgeEh = $event"
                  [readOnly]="true"

></dk-ct-gen-radio-btn>
              </dxi-item>
            </dx-form>
          </div>
        </div>
      </dxi-item>
      <dxi-item
        *ngIf="
          pageData.path === '/BYS/BysGorevForm' ||
          pageData.path === '/BYS/BysGidenEvrakForm' ||
          pageData.path === '/BYS/BysDisBirimGidenForm'
        "
        title="Süreç İzle"
        icon="attach"
      >
        <div class="flex-tab-item">
          <dk-dx-data-table2
            *ngIf="gridCtlSurec$ | async as gridCtl"
            class="grid"
            [tableTittle]="'Süreç Hareketleri'"
            [height]="'100%'"
            [formMetaData]="formMetaData"
            [dListName]="this.dListNameSurec"
            [dataSource]="dataSourceSurec"
            [columnList]="columnListSurec"
            [gridCtlList]="gridCtl"
            [focusedRowIndex]="0"
            (focusedRowChanged)="focusedRowChangedSurec($event)"
          >
          </dk-dx-data-table2>
          <div class="surec-area" *ngIf="focusedRowIndexSurec >= 0">
            <dx-form
              class="form"
              [(formData)]="belgeSurecData"
              [labelMode]="labelMode"
              [labelLocation]="labelLocation"
              [readOnly]="true"
              [colCount]="3"
            >
              <dxi-item
                dataField="BelgeKod"
                [label]="{ text: 'Belge Kod' }"
                editorType="dxNumberBox"
              ></dxi-item>

              <dxi-item
                dataField="SurecAd"
                [label]="{ text: 'Süreç Ad' }"
              ></dxi-item>

              <dxi-item
                dataField="BirimKod"
                [label]="{ text: 'Birim Kod' }"
                editorType="dxNumberBox"
              ></dxi-item>

              <dxi-item
                dataField="BaslamaTarih"
                [label]="{ text: 'Başlama Tarihi' }"
                editorType="dxDateBox"
              ></dxi-item>

              <dxi-item
                dataField="BitisTarih"
                [label]="{ text: 'Bitiş Tarihi' }"
                editorType="dxDateBox"
              ></dxi-item>

              <dxi-item
                dataField="SonucTuru"
                [label]="{ text: 'Sonuç Türü' }"
                editorType="dxNumberBox"
              ></dxi-item>

              <dxi-item
                dataField="SonucTuruAciklama"
                [label]="{ text: 'Sonuç Türü Açıklama' }"
              ></dxi-item>

              <dxi-item
                dataField="SonucAciklama"
                [label]="{ text: 'Sonuç Açıklama' }"
                editorType="dxTextArea"
              ></dxi-item>
            </dx-form>
            <dk-dx-data-table2
              *ngIf="gridCtlSurecDetay$ | async as gridCtl"
              [tableTittle]="'Süreç Detay'"
              [height]="'30vh'"
              [formMetaData]="formMetaData"
              [dListName]="this.dListNameSurecDetay"
              [dataSource]="dataSourceSurecDetay"
              [columnList]="columnListSurecDetay"
              [gridCtlList]="gridCtl"
            >
            </dk-dx-data-table2>
          </div>
        </div>
      </dxi-item>
      <dxi-item
        *ngIf="
          pageData.path !== '/BYS/BysGorevForm' &&
          pageData.path !== '/BYS/BysGidenBelgeOnayForm' &&
          pageData.path !== '/BYS/BysEypMuhurlemeForm'
        "
        title="Evrak İzle"
        icon="attach"
      >
        <div class="flex-tab-item">
          <dk-dx-data-table2
            *ngIf="gridCtlEvrak$ | async as gridCtl"
            class="grid"
            [tableTittle]="'Evrak Hareketleri'"
            [height]="'100%'"
            [formMetaData]="formMetaData"
            [dListName]="this.dListNameEvrak"
            [dataSource]="dataSourceEvrak"
            [columnList]="columnListEvrak"
            [gridCtlList]="gridCtl"
            [focusedRowIndex]="0"
            (focusedRowChanged)="focusedRowChangedEvrak($event)"
          >
          </dk-dx-data-table2>
          <dx-form
            *ngIf="focusedRowIndexEvrak >= 0"
            class="form"
            [(formData)]="belgeEvrakData"
            [labelMode]="labelMode"
            [labelLocation]="labelLocation"
            [readOnly]="true"
            [colCount]="3"
          >
            <dxi-item
              dataField="SiraNo"
              [label]="{ text: 'Sıra No' }"
              editorType="dxNumberBox"
            ></dxi-item>

            <dxi-item
              dataField="BelgeKod"
              [label]="{ text: 'Belge Kod' }"
              editorType="dxNumberBox"
            ></dxi-item>
            <dxi-item
              dataField="Durumu"
              [label]="{ text: 'Durumu' }"
            ></dxi-item>

            <dxi-item
              dataField="BirimAd"
              [label]="{ text: 'Birim Ad' }"
              editorType="dxTextArea"
            ></dxi-item>

            <dxi-item
              dataField="EvrakTarihNo"
              [label]="{ text: 'Evrak Tarih No' }"
            ></dxi-item>

            <dxi-item
              dataField="HavaleDurum"
              [label]="{ text: 'Havale Durum' }"
              editorType="dxTextArea"
            ></dxi-item>

            <dxi-item
              dataField="BilgiGeregi"
              [label]="{ text: 'Bilgi Gereği' }"
            ></dxi-item>

            <dxi-item
              dataField="KayitKullaniciAd"
              [label]="{ text: 'Kayit Kullanıcı Ad' }"
            ></dxi-item>
          </dx-form>
        </div>
      </dxi-item>

      <dxi-item
        *ngIf="
          pageData.path === '/BYS/BysHavaleGorevForm' ||
          pageData.path === '/BYS/BysBelgeIzleForm' ||
          pageData.path === '/BYS/BysEvrakHavaleForm' ||
          pageData.path === '/BYS/BysGelenEvrakForm' ||
          pageData.path === '/BYS/BysEvrakBelgeArama'
        "
        title="Havaleler"
        icon="chevrondoubleright"
      >
        <div class="flex-tab-item">
          <dk-dx-data-table2
            *ngIf="gridCtlHavale$ | async as gridCtl"
            class="grid"
            [tableTittle]="'Havaleler'"
            [height]="'100%'"
            [formMetaData]="formMetaData"
            [dListName]="this.dListNameHavale"
            [dataSource]="dataSourceHavale"
            [columnList]="columnListHavale"
            [gridCtlList]="gridCtl"
            [focusedRowIndex]="0"
            (clickDeleteButton)="showDelete($event)"
            (focusedRowChanged)="focusedRowChangedHavale($event)"
            [cellTemplates]="[{ template: havaleTipiTemplate, field: 'HavaleTipi' }]"
          >
          </dk-dx-data-table2>

          <ng-template #havaleTipiTemplate let-data="itemData" let-index="itemIndex">
              <div *ngIf="data.text == 'Bilgi'" class="blue-bg">Bilgi</div>
              <div *ngIf="data.text == 'Gereği'" class="yellow-bg" >Gereği</div>
          </ng-template>

          <dx-form
            *ngIf="focusedRowIndexHavale >= 0"
            class="form"
            [(formData)]="belgeHavaleData"
            [labelMode]="labelMode"
            [labelLocation]="labelLocation"
            [readOnly]="true"
            [colCount]="3"
          >
            <dxi-item itemType="group" [colSpan]="1">
              <dxi-item
                dataField="BelgeKod"
                [label]="{ text: 'Belge Kod' }"
                editorType="dxNumberBox"
              ></dxi-item>
              <dxi-item
                dataField="HavaleTarih"
                [label]="{ text: 'Havale Tarih' }"
                editorType="dxDateBox"
              ></dxi-item>
              <dxi-item
                dataField="HavaleTipi"
                [label]="{ text: 'Havale Tipi' }"
              ></dxi-item>
              <dxi-item
                dataField="HavaleAciklama"
                [label]="{ text: 'Havale Açıklama' }"
                editorType="dxTextArea"
              ></dxi-item>
            </dxi-item>
            <dxi-item itemType="group" [colSpan]="1">
              <dxi-item
                dataField="BirimKod"
                [label]="{ text: 'Birim Kod' }"
                editorType="dxNumberBox"
              ></dxi-item>

              <dxi-item
                dataField="EvrakKod"
                [label]="{ text: 'Evrak Kod' }"
                editorType="dxNumberBox"
              ></dxi-item>

              <dxi-item
                dataField="PersonelKod"
                [label]="{ text: 'Personel Kod' }"
                editorType="dxNumberBox"
              ></dxi-item>
            </dxi-item>
            <dxi-item itemType="group" [colSpan]="1">
              <dxi-item
                dataField="SonucTarih"
                [label]="{ text: 'Sonuç Tarih' }"
                editorType="dxDateBox"
              ></dxi-item>
              <dxi-item
                dataField="SonucTurKod"
                [label]="{ text: 'Sonuç Türü' }"
                editorType="dxNumberBox"
              ></dxi-item>
              <dxi-item
                dataField="SonucAciklama"
                [label]="{ text: 'Sonuç Açıklama' }"
                editorType="dxTextArea"
              ></dxi-item>
            </dxi-item>
          </dx-form>
        </div>
      </dxi-item>
      <dxi-item
      title="Loglar"
      icon="taskhelpneeded"
    >
      <div class="flex-tab-item">
        <dk-dx-data-table2
          *ngIf="gridCtlLog$ | async as gridCtl"
          class="grid"
          [tableTittle]="'Belge Hareketleri'"
          [height]="'100%'"
          [formMetaData]="formMetaData"
          [dListName]="this.dListNameLog"
          [dataSource]="dataSourceLog"
          [columnList]="columnListLog"
          [gridCtlList]="gridCtl"
          [dontSelectDataSource]="true"
        ><!-- DKM-5514 Cedric: birleşik hareket listesi (CustomStore); select SatirKey anahtarını düşürmesin -->
        </dk-dx-data-table2>
      </div>
    </dxi-item>
    <dxi-item
        *ngIf="
          pageData.path === '/BYS/BysDisBirimGidenForm' ||
          pageData.path == '/BYS/BysDisEvrakForm' || 
          pageData.path == '/BYS/BysGelenEvrakForm' ||
          pageData.path == '/BYS/BysGidenEvrakForm' ||
          pageData.path == '/BYS/BysGorevForm' ||
          pageData.path == '/BYS/BysHavaleGorevForm' ||
          pageData.path == '/BYS/BysBelgeIzleForm' ||
          pageData.path == '/BYS/BysEvrakHavaleForm' ||
          pageData.path == '/BYS/BysGidenBelgeOnayForm'
        "
        title="Notlar"
        icon="textdocument"
      >
            <div class="flex-tab-item">
        <dk-dx-data-table2
          *ngIf="gridCtlNot$ | async as gridCtl"
          class="grid"
          [tableTittle]="'Notlar'"
          [height]="'100%'"
          [formMetaData]="formMetaData"
          [dListName]="this.dListNameNot"
          [dataSource]="dataSourceNot"
          [columnList]="columnListNot"
          [gridCtlList]="gridCtl"
           (clickDeleteButton)="showDeleteBysNot($event)"
          (clickAddCustomButton)="showAddBysNot()"
          [tableAddNewButton]="{ newButtonText: 'Yeni Not Ekle',disable: !formMetaData.formYetki.insertYn }"
        >
        </dk-dx-data-table2>
      </div>

      </dxi-item>
    </dx-tab-panel>
    <ng-container *ngIf="showBelge">
      <dk-form-popup
        [formMetada]="formMetaData"
        [state]="'View'"
        [popupName]="'BysBelgeEk'"
        [visible]="showBelge"
        (visibleChange)="showBelge = $event"
        [height]="'80vh'"
        [width]="'40vw'"
        [title]="'Belge Görüntüle'"
      >


      <ng-container *ngIf="documentLoad">
            
        <dk-doc-viewer-manager
        [url]="fileUrlEk"
      [isFileImage]="isFileImage"
      [guvenliHtml]="htmlEk"
      [failedDocMessage]="failedDocLoadMsg"
      [documentLoad]="documentLoad"
      [docId]="docId"
      [width]="770"   
      [height]="840"
      ></dk-doc-viewer-manager> 
  </ng-container>

<!-- 
        <div class="belge-viewer">
          <img
            *ngIf="isFileImage && documentLoad; else documentTemplate"
            [src]="fileUrlEk"
            (error)="onFileError()"
          />
        </div>

        <ng-template #documentTemplate>
          <iframe
            type="application/pdf"
            *ngIf="!isFileImage && documentLoad; else noTemplate"
            [src]="fileUrlEk"
            (load)="onDocumentLoad()"
            (error)="onFileError()"
          ></iframe>
        </ng-template>

        <ng-template #noTemplate>
          <div class="error-message">{{ failedDocLoadMsg }}</div>
        </ng-template> -->
      </dk-form-popup>
    </ng-container>
</div>



<dk-form-popup
    *ngIf="showBelgeIlgi"
    [formMetada]="formMetaData"
    [state]="'View'"
    [popupName]="'BysBelge'"
    [visible]="showBelgeIlgi"
    (visibleChange)="showBelgeIlgi = $event"
    [height]="'70vh'"
    [width]="'70vw'"
    [title]="'Belge Görüntüle'"
  >
    <dk-ust-yazi-popup [belgeKod]="belgeIlgiData?.ReferansKod"> </dk-ust-yazi-popup>
  </dk-form-popup>


  <dk-form-popup
  *ngIf="bysBelgeNotPopupVisible"
  width="350px"
  [visible]="bysBelgeNotPopupVisible"
  (visibleChange)="bysBelgeNotPopupVisible = $event"
  [title]="'Not Ekle'"
  [popupName]="'BysBelgeNot'"
  [formMetada]="formMetaData"
  [displayEditBtn]="false"
>
  <dk-pdf-view-belge-not-crud-popup
    [selectedRow]="selectedBysBelgeNotRow"
    [formMetaData]="formMetaData"
    (closePopup)="closeAfterPopupBelgeNot($event)"
  ></dk-pdf-view-belge-not-crud-popup>
</dk-form-popup>
